export var ActivitySortType;
(function (ActivitySortType) {
    ActivitySortType["StartsAtDateDescending"] = "StartsAtDateDescending";
    ActivitySortType["StartsAtDateAscending"] = "StartsAtDateAscending";
    ActivitySortType["ParticipationRewardDescending"] = "ParticipationRewardDescending";
    ActivitySortType["ParticipationRewardAscending"] = "ParticipationRewardAscending";
    ActivitySortType["NameAscending"] = "NameAscending";
    ActivitySortType["NameDescending"] = "NameDescending";
})(ActivitySortType || (ActivitySortType = {}));
